/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

import { Injectable } from "@angular/core";
import { RestAPI } from "@aws-amplify/api-rest";

@Injectable({ providedIn: 'root' })
export class AWSLambda {
  async getLambdaFunction(apiName: string = "MyApiName", path: string = '/path', init: object = {}): Promise<any> {
    return RestAPI.get(apiName, path, init).catch( e => {
      throw Error(JSON.stringify(e.response.data))
    })
  }
}
